var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SiteSearch360',{attrs:{"site-id":"statecs.am_1","ss360-config":_vm.ss360Config}})}
var staticRenderFns = []

export { render, staticRenderFns }